import { gql } from "@apollo/client";
import { accProjectDetailsType, countryType, imageType } from "../constants";

export const GET_PROJECT_DETAIL = gql`
  query ($id: ID!) {
    getHouse(id: $id) {
      id
      displayName
      model
      location
      country {
        ${countryType}
      }
      images {
        ${imageType}
      }
      createdBy {
        id
        displayName
        photoUrl
      }
      team {
        id
        photoUrl
        displayName
        email
      }
      bom {
        status
      }
      createdAt
      typeOfProject
      matchEngineSettings {
        locations
        standards
      }
      region
      source
      viewDisplayName
      viewGuid
      compoundLayer {
        status
      }
      accProjectDetails{
        ${accProjectDetailsType}
      }
      constructionDate
    }
  }
`;

export const GET_BOM_PRODUCTS = gql`
  query ($houseId: String!) {
    getBOMProducts(houseId: $houseId) {
      objectId
      productId
      productName
      paramType
      product {
        id
        displayName
        images {
          ${imageType}
        }
        categories {
          id
          displayName
        }
        brand {
          id
          displayName
        }
        properties {
          id
          value
          values
        }
        sustainabilityRanks {
          environmental
          economic
          social
        }
      }
    }
  }
`;

export const GET_BOM_METADATA = gql`
  query ($houseId: String!) {
    getBOMMetaData(houseId: $houseId) {
      objectid
      name
      childrenLength
      environmental
      economic
      social
      carbonEmission
      price
      insertDataOnly
      insertDataInsteadOfInsertModel
      insertModelPlusData
      insertModelPlusTemplateFilePlusData
      outdatedInDesign
      removedFromLibrary
      diff {
        label
        bmObjectPropertyValue
        productPropertyValue
      }
    }
  }
`;

export const DELETE_HOUSE = gql`
  mutation DeleteHouse($id: ID!) {
    deleteHouse(id: $id) {
      status
      message
    }
  }
`;

export const UPDATE_HOUSE_ACC_FILE = gql`
  mutation UpdateHouseAccFile($id: ID!, $input: HouseAccFileInput!) {
    updateHouseAccFile(id: $id, input: $input) {
      id
      bom {
        status
      }
      accProjectDetails {
        ${accProjectDetailsType}
      }
    }
  }
`